import React, {useState} from "react";
import TopBar from "../globalComponents/topbar";
import Footer from "../globalComponents/footer";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 1300,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 92,
					}}>
					<TopBar/>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 267,
						}} >
						{"Bookmarks"}
					</span>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginBottom: 38,
						}}>
						<span 
							style={{
								color: "#6C6C6C",
								fontSize: 18,
								marginRight: 35,
							}} >
							{"Explore all resources"}
						</span>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 44,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Bookmarks Resources"}
							</span>
							<div 
								style={{
									width: 752,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 12,
									paddingBottom: 12,
									paddingLeft: 33,
									paddingRight: 387,
									marginBottom: 16,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8mdwc12w_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search resources..."}
									value={input2}
									onChange={(event)=>onChangeInput2(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 124,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									gap: 12,
								}}>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 4,
										border: "none",
										paddingTop: 6,
										paddingBottom: 6,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"All"}
									</span>
								</button>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 4,
										border: `1px solid #E6E6E6`,
										paddingTop: 6,
										paddingBottom: 6,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#979797",
											fontSize: 12,
										}} >
										{"Articles"}
									</span>
								</button>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 4,
										border: `1px solid #E6E6E6`,
										paddingTop: 6,
										paddingBottom: 6,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#979797",
											fontSize: 12,
										}} >
										{"Videos"}
									</span>
								</button>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 4,
										border: `1px solid #E6E6E6`,
										paddingTop: 6,
										paddingBottom: 6,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#979797",
											fontSize: 12,
										}} >
										{"Templates"}
									</span>
								</button>
								<button 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 4,
										border: `1px solid #E6E6E6`,
										paddingTop: 6,
										paddingBottom: 6,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#979797",
											fontSize: 12,
										}} >
										{"Case Studies & Reports"}
									</span>
								</button>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									gap: 28,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 4,
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/uyzvqwzh_expires_30_days.png"} 
											style={{
												width: 61,
												height: 61,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 23,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"How to Build a Business Plan"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Article"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 239,
												}} >
												{"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris pellentesque, odi"}
											</span>
										</div>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 10,
											fontWeight: "bold",
											marginBottom: 12,
											marginLeft: 89,
										}} >
										{"Read Time: 6 min"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 39,
												paddingRight: 41,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7zyv54lp_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Read More"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 34,
												paddingRight: 36,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xuqkjsxs_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Bookmarked"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 4,
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9mdd2j06_expires_30_days.png"} 
											style={{
												width: 61,
												height: 61,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 23,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"How to Build a Business Plan"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Article"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 239,
												}} >
												{"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris pellentesque, odi"}
											</span>
										</div>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 10,
											fontWeight: "bold",
											marginBottom: 12,
											marginLeft: 89,
										}} >
										{"Read Time: 6 min"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 39,
												paddingRight: 41,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/r6s6kl9y_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Read More"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 34,
												paddingRight: 36,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7bpqs11v_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Bookmarked"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									gap: 28,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
										gap: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/x6ykx9r9_expires_30_days.png"} 
											style={{
												width: 61,
												height: 61,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 48,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"Business Plan Template"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Template"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 252,
												}} >
												{"A structured business plan template to help you outline your vision, strategy, and financial projections."}
											</span>
										</div>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 27,
												paddingRight: 29,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/uoxhbeo3_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"View"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 5,
												paddingRight: 6,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/60dpzpxn_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Bookmarked"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 14,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/axzcdsdo_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Download"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
										gap: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rprov4vn_expires_30_days.png"} 
											style={{
												width: 61,
												height: 61,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 48,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"Business Plan Template"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Template"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 252,
												}} >
												{"A structured business plan template to help you outline your vision, strategy, and financial projections."}
											</span>
										</div>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 27,
												paddingRight: 29,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8g9hs1e2_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"View"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 5,
												paddingRight: 6,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/on28fjiy_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Bookmarked"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 14,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0q11p1ie_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Download"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									gap: 28,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 4,
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/g1buqycm_expires_30_days.png"} 
											style={{
												width: 61,
												height: 61,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 23,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"How to Build a Business Plan"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Article"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 239,
												}} >
												{"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris pellentesque, odi"}
											</span>
										</div>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 10,
											fontWeight: "bold",
											marginBottom: 12,
											marginLeft: 89,
										}} >
										{"Read Time: 6 min"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 39,
												paddingRight: 41,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7uub2369_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Read More"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 34,
												paddingRight: 36,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xvs3susn_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Bookmarked"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 4,
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ptdlhrmm_expires_30_days.png"} 
											style={{
												width: 61,
												height: 61,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 23,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"How to Build a Business Plan"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Article"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 239,
												}} >
												{"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris pellentesque, odi"}
											</span>
										</div>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 10,
											fontWeight: "bold",
											marginBottom: 12,
											marginLeft: 89,
										}} >
										{"Read Time: 6 min"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 39,
												paddingRight: 41,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kvj0llpj_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Read More"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 34,
												paddingRight: 36,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0ggpg5vr_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Bookmarked"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									gap: 28,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
										gap: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sh8r1ovw_expires_30_days.png"} 
											style={{
												width: 61,
												height: 61,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 48,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"Business Plan Template"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Template"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 252,
												}} >
												{"A structured business plan template to help you outline your vision, strategy, and financial projections."}
											</span>
										</div>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 27,
												paddingRight: 29,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zkwd9rw1_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"View"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 5,
												paddingRight: 6,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7x3s35lc_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Bookmarked"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 14,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/iisss1vv_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Download"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
										gap: 16,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tn6p6k1z_expires_30_days.png"} 
											style={{
												width: 61,
												height: 61,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 8,
											}}>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													gap: 48,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
													}} >
													{"Business Plan Template"}
												</span>
												<div 
													style={{
														flexShrink: 0,
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-start",
														background: "linear-gradient(180deg, #F57E47, #F36421)",
														borderRadius: 2,
														paddingTop: 2,
														paddingBottom: 2,
														paddingLeft: 4,
														paddingRight: 4,
													}}>
													<span 
														style={{
															color: "#FFFFFF",
															fontSize: 8,
															fontWeight: "bold",
														}} >
														{"Template"}
													</span>
												</div>
											</div>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
													width: 252,
												}} >
												{"A structured business plan template to help you outline your vision, strategy, and financial projections."}
											</span>
										</div>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 16,
											marginRight: 16,
											gap: 12,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 27,
												paddingRight: 29,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0r4sm7i9_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"View"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 5,
												paddingRight: 6,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hw1xezqs_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Bookmarked"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 8,
												paddingBottom: 8,
												paddingLeft: 12,
												paddingRight: 14,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/oqgff409_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Download"}
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1074,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
									marginLeft: 23,
								}} >
								{"Library Filters"}
							</span>
							<div 
								style={{
									width: 277,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
									marginLeft: 23,
									marginRight: 23,
								}}>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 16,
									marginLeft: 22,
								}} >
								{"Content Type"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 212,
									}} >
									{"Articles"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6BD0F6",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 216,
									}} >
									{"Videos"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 5,
										padding: 1,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gl7rpw48_expires_30_days.png"} 
										style={{
											width: 15,
											height: 15,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 194,
									}} >
									{"Templates"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 27,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 176,
									}} >
									{"Case Studies"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									width: 323,
									height: 6,
									background: "#F1F2F4",
									marginBottom: 29,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 189,
									}} >
									{"Category"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/q1hz2o2e_expires_30_days.png"} 
									style={{
										width: 19,
										height: 19,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 144,
									}} >
									{"Business Strategy"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 145,
									}} >
									{"Marketing & Sales"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 142,
									}} >
									{"Finance & Funding"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 150,
									}} >
									{"Entrepreneurship"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 28,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 157,
									}} >
									{"Technology & AI"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									width: 324,
									height: 6,
									background: "#F1F2F4",
									marginBottom: 28,
								}}>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 16,
									marginLeft: 22,
								}} >
								{"Popularity & Relevance"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 132,
									}} >
									{"Trending Resources"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 144,
									}} >
									{"Most Downloaded"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
									gap: 32,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
									}} >
									{"AI-Personalized Recommendations"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 180,
									}} >
									{"Newest First"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 24,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 187,
									}} >
									{"Oldest First"}
								</span>
								<div 
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<button 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #00000000`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 110,
									paddingRight: 110,
									marginBottom: 8,
									marginLeft: 22,
									marginRight: 22,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#6BD0F6",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Clear"}
								</span>
							</button>
							<button 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									border: "none",
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 107,
									paddingRight: 107,
									marginLeft: 22,
									marginRight: 22,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#FFFFFF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Apply"}
								</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<Footer/>
		</div>
	)
}